import HitDieDice from "./HitDieDice";

export default HitDieDice;
